document.addEventListener("DOMContentLoaded", function () {
    // Get the button element to open the modal
    var newModalBtnLink = document.getElementById("newModalBtnLink");
    var newModal = document.getElementById("newModal");
    var newCloseModalBtn = document.getElementById("newCloseModalBtn");

    // Get a reference to the "BOOK AN APPOINTMENT" button for Calendly
    var newOpenCalendlyBtn = document.getElementById("newOpenCalendlyBtn");

    // Get a reference to the .new-modal-content element
    var newModalContent = document.querySelector(".new-modal-content");

    // Function to open the modal
    function openModal() {
        newModal.style.display = "block";
        newModalContent.style.display = "block"; // Show the modal content
    }

    // Event listener for the button to open the modal
    if (newModalBtnLink) {
      newModalBtnLink.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent the default link behavior
        openModal(); // Open the modal
      });
    }

    // Function to close the modal
    function closeModal() {
        newModal.style.display = "none";
        newModalContent.style.display = "none"; // Hide the modal content
    }

    // Event listener for the close button to close the modal
    if (newCloseModalBtn) {
      newCloseModalBtn.addEventListener("click", closeModal);
    }

    // Event listener to close the modal when clicking outside the modal content
    window.addEventListener("click", function (event) {
        if (event.target === newModal) {
            closeModal();
        }
    });

    // Function to open the Calendly widget
    function openCalendlyWidget() {
        // Call Calendly's initPopupWidget function
        Calendly.initPopupWidget({
            url: 'https://calendly.com/contact-scs/30min?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=1a1a1a'
        });
    }  

    // Event listener to open the Calendly widget when clicking "BOOK AN APPOINTMENT"
    if (newOpenCalendlyBtn) {
      newOpenCalendlyBtn.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent the default link behavior
        closeModal(); // Close the modal
        openCalendlyWidget(); // Open the Calendly widget
      });
    }   

    // Hide the modal initially
    if (newModal) {
      newModal.style.display = "none";
    }    
});
